Ext.define('SA.EditScatterPlotAttributesRequiredRule', {
    constructor(model) {
        this.model = model;
    },

    getMessage() {
        return !this.model.getProject().hasAttributes()
            ? 'Please add data to the project.'
            : 'Please select one x and one y data variable for your Scatter Plot.';
    },

    isBroken() {
        return !(this.model.hasXAttribute() && this.model.hasYAttribute());
    }
});